import i18n from 'i18next'
import locales from '../../translations/locales.json'

const languageMapping: Record<string, string> = locales.reduce(
	(mapping, language) => {
		const languageSubTag = language.languageCode.split('-')[0]!
		return {
			...mapping,
			[languageSubTag]: language.languageCode,
		}
	},
	{},
)

export const getLocalizedLanguageCode = (
	inputLanguageCode?: string,
): string => {
	const languageCode = inputLanguageCode ?? i18n.language

	if (languageCode === 'cimode' || !languageCode.includes('-')) {
		return languageCode
	}
	const baseLanguage = languageCode.split('-')[0]!

	return languageMapping[baseLanguage] ?? 'en-GB'
}
